module.exports = __webpack_public_path__ + "static/media/arrow.1c90682e.svg";